import { Space, SpaceProps } from 'component/Space/Space'

export function Vertical(props: SpaceProps) {
  return <Space vertical {...props} />
}
